import { Component, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RdxLabelDirective } from '@radix-ng/primitives/label';
import { RdxSwitchRootDirective, RdxSwitchThumbDirective } from '@radix-ng/primitives/switch';
import { BaseControlValueAccessor } from '../form/directives/base-control-value-accesor.directive';

@Component({
  templateUrl: './switch.component.html',
  selector: 'ds-switch',
  imports: [
    FormsModule,
    RdxLabelDirective,
    RdxSwitchRootDirective,
    RdxSwitchThumbDirective
  ],
})
export class SwitchComponent extends BaseControlValueAccessor<boolean> {
  override $value = input<boolean | null>(true, { alias: 'value' });
  $size = input<string>('s', { alias: 'size' });
  $text = input<string>('Label', { alias: 'text' });
  $id = input<string>('toggle-id', { alias: 'id' });

  valueChange = output<boolean>();

  onToggleChange(newCheckedState: boolean | undefined): void {
    if (this.$disabled() || newCheckedState === undefined) { return; }
    this.onChange(newCheckedState);
    this.valueChange.emit(newCheckedState);
  }
}
